import { useStoreContext } from "../../..";
import { FieldTypeId } from "../../../lib/enums";
import { CustomForm } from "../../customform/CustomForm";
import CustomDatePicker from "../../customform/fields/DateTime/CustomDatePicker";
import FormRow from "../../customform/layout/FormRow";
import {
  Measurement,
  MeasurementSaveRequest,
  MeasurementSaveRequestSchema,
} from "../../../models/Measurements";
import { observer } from "mobx-react";
import HiddenStaticValue from "../../customform/fields/Text/HiddenStaticValue";
import CustomSelect from "../../customform/fields/Select/CustomSelect";
import { useEffect, useState } from "react";

interface Props {
  selectedDay: Measurement | undefined;
  onDeSelect: () => void;
}

const VaccinationEntryForm = observer(({ selectedDay, onDeSelect }: Props) => {
  const { measurementStore, fieldStore } = useStoreContext();

  const [measurementId, setMeasurementId] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    setMeasurementId(selectedDay?.measurementId);
  }, [selectedDay]);

  const saveVaccination = (data: any) => {
    measurementStore.saveMeasurement(data as MeasurementSaveRequest);
  };

  const updateEntry = (data: any) => {
    if (measurementId) {
      console.log(data);
      measurementStore.updateMeasurement(
        measurementId,
        data as MeasurementSaveRequest
      );
      onDeSelect();
    }
  };

  return (
    <>
      <CustomForm
        zodDataSchema={MeasurementSaveRequestSchema}
        hideDeleteAndEditButtons
        hideReadOnlyChip
        hideSaveButton
        currentData={selectedDay as any}
        onSave={saveVaccination}
        onUpdate={updateEntry}
        onDeSelect={onDeSelect}
      >
        <HiddenStaticValue
          alias="fieldAlias"
          value="D_VaccinationType"
          nonForm
        />
        <FormRow gapAfter>
          <CustomDatePicker
            required
            alias="date"
            header="Datum"
            fieldId={0}
            typeId={FieldTypeId.DATE}
            nonForm
            validations={[
              {
                isNotInFuture: "date",
              },
            ]}
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomSelect
            nonForm
            fieldId={0}
            required
            alias="value"
            header="Vaccinationer"
            fieldOptions={fieldStore.vaccinesOptionsList as any}
            labelProp="name"
            valueProp="id"
            typeId={FieldTypeId.DROPLIST}
            validations={[{ isNonNegative: "value" }]}
          />
        </FormRow>
      </CustomForm>
    </>
  );
});

export default VaccinationEntryForm;
